import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeTrackingService } from '../api/time-tracking.service';
import { TIME_TRACKING_KEYS } from './queryKeys';
import type { CreateManualEntryPayload, UpdateTimeEntryPayload } from '../types';

export function useCreateManualEntry(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (payload: CreateManualEntryPayload) =>
      timeTrackingService.createManualEntry(taskId, payload),
    onSuccess: () => {
      // byOrg covers task + project/user entries consumed by reports
      queryClient.invalidateQueries({ queryKey: TIME_TRACKING_KEYS.byOrg(orgId ?? '') });
    },
  });
}

export function useUpdateTimeEntry(_taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateTimeEntryPayload }) =>
      timeTrackingService.updateTimeEntry(id, payload),
    onSuccess: () => {
      // byOrg covers task + project/user entries consumed by reports
      queryClient.invalidateQueries({ queryKey: TIME_TRACKING_KEYS.byOrg(orgId ?? '') });
    },
  });
}

export function useDeleteTimeEntry(_taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (id: string) => timeTrackingService.deleteTimeEntry(id),
    onSuccess: () => {
      // byOrg covers task + project/user entries consumed by reports
      queryClient.invalidateQueries({ queryKey: TIME_TRACKING_KEYS.byOrg(orgId ?? '') });
    },
  });
}
